import React from "react";

const Error = ({ error }) => {
  const defaultErrorMessage = "There was an error, please refresh the page.";
  return (
    <div className="flex h-screen">
      <div className="m-auto">
        <h2>{error || defaultErrorMessage}</h2>
      </div>
    </div>
  );
};

export default Error;
